var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Report\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7998047,6.2011719 L16.2998047,6.2011719 L16.2998047,7.7011719 L6.7998047,7.7011719 L6.7998047,6.2011719 Z M6.7998047,9.3007812 L16.2998047,9.3007812 L16.2998047,10.8007812 L6.7998047,10.8007812 L6.7998047,9.3007812 Z M6.7998047,12.3007812 L16.2998047,12.3007812 L16.2998047,13.8007812 L6.7998047,13.8007812 L6.7998047,12.3007812 Z M18.5,18.5 L4.5,18.5 L4.5,1.5 L18.5,1.5 L18.5,18.5 Z M1.5,1.5 L3,1.5 L3,18.5 L1.5,18.5 L1.5,1.5 Z M0,0 L0,20 L20,20 L20,0 L0,0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.ea6d59ba6dbe89855176af51c9a91afa.svg";
export { ForwardRef as ReactComponent };